import React from "react";
import { Link } from "react-router-dom";
import { Checkbox } from "../ui/checkbox";

export default function ConsentCheck({ checked, onChange, testid = "consent", light = false, short = false }) {
  return (
    <label className={`flex items-start gap-3 cursor-pointer select-none text-sm leading-relaxed ${light ? "text-[#faf7f0]/80" : "text-[#5a6158]"}`} data-testid={`${testid}-label`}>
      <Checkbox checked={checked} onCheckedChange={(v) => onChange(v === true)} data-testid={testid}
        className={`mt-0.5 h-5 w-5 rounded-md ${light ? "border-[#faf7f0]/60 data-[state=checked]:bg-[#d9895a] data-[state=checked]:text-[#13261c]" : "border-[#b3ab98] data-[state=checked]:bg-[#13261c]"}`} />
      <span>
        {short ? "J'accepte de recevoir les conseils d'Ouest Conciergerie." : "J'accepte d'être recontacté(e) par Ouest Conciergerie au sujet de ma demande."} *{" "}
        <Link to="/confidentialite" className={`underline ${light ? "hover:text-white" : "hover:text-[#13261c]"}`}>Confidentialité</Link>
      </span>
    </label>
  );
}
